module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/features/3-f22ecd77e880acc7cbbffa119062e028.svg";